import React from 'react';
import { useStaticQuery, graphql, navigate } from 'gatsby';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import styled from 'styled-components';

const CategoriesFilterContainer = styled.div`
  & ul {
    display: flex;
    justify-content: start;
    flex-wrap: wrap;
    list-style: none;
    padding: 0.25em;
    margin: 0 0 1.5rem;

    & li {
      margin: 0.25em;
    }
  }
`;

interface CategoriesFilterProps {
  selectedCategorySlug: string | null;
}

const CategoriesFilter = ({ selectedCategorySlug }: CategoriesFilterProps) => {
  const parentTheme = useTheme();
  const theme = createTheme({
    ...parentTheme,
    palette: {
      ...parentTheme.palette,
      secondary: {
        main: '#646464',
      },
    },
  });

  const {
    allWpCategory: { nodes: allCategories },
  } = useStaticQuery(graphql`
    query CategoriesQuery {
      allWpCategory(
        sort: { fields: acfCategory___order }
        filter: {acfCategory: {active: {eq: true}}}
      ) {
        nodes {
          acfCategory {
            order
          }
          name
          slug
          description
        }
      }
    }
  `);

  if (selectedCategorySlug && !allCategories.some((category) => category.slug === selectedCategorySlug)) {
    navigate('/');
  }

  const categories = [{ name: 'Wszystkie', slug: null }, ...allCategories];

  return (
    <CategoriesFilterContainer>
      <ThemeProvider theme={theme}>
        <ul>
          {categories.map(({ name, slug }) => {
            const isSelected = selectedCategorySlug === slug;
            return (
              <li key={slug || 'all'}>
                <Button
                  component="a"
                  href={slug ? `/ekartki-${slug}` : '/'}
                  variant={isSelected ? 'contained' : 'outlined'}
                  color="secondary"
                  sx={{ fontWeight: isSelected ? 600 : 500 }}
                >
                  {name}
                </Button>
              </li>
            );
          })}
        </ul>
      </ThemeProvider>
    </CategoriesFilterContainer>
  );
};

export default CategoriesFilter;
